import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class VendingItem extends Phaser.GameObjects.Sprite {
    id: number;
    name: string;
    cost: number;
    currentAmount: number;
    paid: boolean;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, id: number) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "-little");
        this.id = id;
        this.name = ob.name;
        this.cost = ob.properties["cost"] as number;
        this.currentAmount = 0;
        this.paid = false;

        this.setDepth(2);
        this.setInteractive({ useHandCursor: true });
        this.scene.add.existing(this);
    }

    free(newX: number, newY: number) {
        this.disableInteractive();

        this.scene.tweens.add({
            targets: this,
            y: 650,
            ease: "Linear",
            duration: 1000,
            onStart: () => {
                this.scene.input.enabled = false;
            },
            onComplete: () => {
                this.scene.input.enabled = true;
                var purchasedItem = this.scene.add.sprite(newX, newY, "assets", this.name + "-big");
                purchasedItem.setScale(0.75);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/VendingMachine/objects/VendingItem.ts